module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("Section 1:")]), _vm._v(" "), _c('h2', {
    staticClass: "h2a"
  }, [_vm._v("Shunting Locomotives")]), _vm._v(" "), _c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "sec1-1"
    }
  }, [_vm._v("1.1: Pre-Nationalization Designs")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Whilst many steam locomotive manufacturers had begun the development of small diesel shunting locomotives after their success in the First World War, the main line railway companies remained committed to steam locomotives with most locomotives being built within their own workshops. One major exception was the London Midland Scottish Railway Company (LMSR) which by the late 1920s had identified steam locomotive shunters as an expense which needed to be reduced and began trialling locomotives from outside builders during the 1930s as it sought to identify standard designs for its future needs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Turning to established builders the LMSR bought small shunters (100–250 hp) from the Hunslet Engine Company Ltd and large shunters (300–400 hp) from both Armstrong Whitworth and English Electric for comparison.")]), _vm._v(" "), _c('p', {
    staticClass: "h4_1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("1.1.1: Hunslet Engine Co Ltd")])]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Builder")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Hunslet Engine Co")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Year Built")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1933")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Engine")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("MAN 6-Cylinder 150 hp @ 900 rpm")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Transmission")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Mechanical")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("LMSR Fleet Numbers")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("7401–7404 (later 7051–7054)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Ordered as one of four locomotives with different combinations of engine and transmission, 7401 was operated from Leeds Hunslet Road adjacent to its builder’s workshops. It was renumbered 7051 by the LMSR in 1934 and by 1936 was based at Chester. At the onset of the Second World War the four locomotives were borrowed by the War Department (WD) with 7051 being returned to, and borrowed from, the LMSR during 1940–45. On return to the LMSR in 1945, 7051 was sold to Hunslet in December 1945. The locomotive was fitted with a McLaren Ricardo MR6 diesel engine rated at 132 hp and used for short-term hire until being sold to the Middleton Railway Trust in 1960, where it was named "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("John Alcock.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "fimg"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg8-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("7051 is in LMS guise as it works a shuttle service on the demonstration line at Barrow Hill (BHR) during a diesel gala on 5 October 2003.")])])]), _vm._v(" "), _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "sec1-1-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("1.1.2: London Midland Scottish Railway Company")])]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Builder")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("LMSR/BR Derby; BR Darlington")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Year Built")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1945–1952")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Engine")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("English Electric 6-cylinder 6KT rated at 350 hp @ 680 rpm")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Transmission")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Electric")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Fleet Numbers")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("LMSR = 7100–7109; 7120–7155; BR = 12033–12138")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("AD601 was the 13th locomotive built as part of the order for twenty supplied to the Ministry of Supply in 1945 and was delivered to Longmoor Military Railway (LMR). It was subsequently renumbered to 878 in 1952 and finally to AD601 in 1980 prior to being sold to the Lakeside & Haverthwaite Railway (LHR) in December 1980. On the LHR it sometimes (confusingly) carries LMSR guise as 7120 although the original LMSR 7120 was renumbered to 12033 by BR and withdrawn from service in January 1969.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("History:")]), _vm._v(" The LMSR was interested in a large shunter for use in busy yards and light inter-yard trip working and trialled two designs in 1935 – placing orders with Armstrong Whitworth (AW) (LMSR Nos. 7059–7068) using a Sulzer engine and jackshaft electrical transmission and Hawthorn Leslie (HL) (LMSR Nos. 7069–7078) using an English Electric engine and electric transmission linked directly to a traction motor on each outer axle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The result of the trials was to identify the AW locomotives layout as superior but the company had ceased locomotive production in 1937 to concentrate on armaments production, hence the LMSR elected to build further locomotives at its Derby works.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It initially built thirty locomotives (LMSR Nos. 7080–7099 and 7110–7119) to the AW layout, albeit with English Electric 6KT engines, but subsequently adopted the HL drive train (LMSR Nos. 7100–7109) for the War Department in 1940 and this became the standard configuration for future designs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Further orders to the ‘standard’ design appeared in the 1940s with orders for LMSR 7120–32 (later BR 12033–45) and Ministry of Supply 70260–70273; after the Second World War the LMSR continued building the class and this continued after the 1948 nationalization with Derby finalising building at 12102 whilst a batch of locomotives (12103–12138) was delivered from Darlington Works for the Eastern Region (ER) of BR between March 1952 and January 1953.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "fimg"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg9-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("AD601 approaches Newby Bridge (LHR) on 6 March 2015 whilst working the Lakeside–Haverthwaite leg of a railway tour chartered by the Preserved Locomotives Enthusiasts Group (PLEG).")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "fimg"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg10-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(" 12077 acts as shed pilot on 8 November 2014 whilst shunting Standard Class 5 4-6-0 73129 into the shed building at Swanwick Junction (MRC).")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("12077 entered service at Saltley depot in October 1950 and was withdrawn from Wigan Springs Branch depot in October 1971. It was sold into industrial service in 1972 from where it entered preservation with the Midland Railway Centre (MRC) at Butterley in February 1979.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("12099 entered service at Nottingham depot in February 1952 and was withdrawn from Bletchley depot in July 1971. It was sold into industrial service in March 1972 from where it entered preservation with the Severn Valley Railway (SVR) in March 1990.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "fimg"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg10-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(" 12099 is paired with Class 08 D3201 as they approach Kidderminster (SVR) on 2 October 2015 whilst hauling the 10:10 Bewdley–Kidderminster service during the annual diesel gala event.")])])]), _vm._v(" "), _c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "sec1-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("1.2: Post-Nationalization Designs")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When the UK railway companies were formed into British Railways (BR) from 1 January 1948, the LMSR became the London Midland Region (LMR) and continued building its 0-6-0 diesel design. That design however was found to be too heavy for smaller yards such as industrial sidings and docksides hence the nascent BR turned to industry for smaller 0-4-0 and 0-6-0 designs with power ranges from 150 hp to 250 hp.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This demand was met by such builders as Andrew Barclay (D2400–2409; D2410–2444; D2953–2956); Drewry Car (D2200–2214; D2215–2273; D2274–2341); Hudswell Clarke (D2500–2519; D2550–2618); Hunslet Engine Co (D2950–2952); North British Locomotive Co (D2700–2707; D2708–2780; D2900–2913); Ruston & Hornsby (PWM651–654; D2957–2958; D2985–2998) and Yorkshire Engine Co (D2850–2869) whilst BR’s workshops at Swindon and Doncaster shared the production of D2000–2199; D2372–2399.")]), _vm._v(" "), _c('p', {
    staticClass: "h4_1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("1.2.1: Pre-TOPS Designs")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("BR introduced its TOPS (Total Operations Processing System) in the late 1960s and extended it to cover its locomotive fleet in the early 1970s by which time the changed operating environment of the railways had led to the withdrawal of many diesel shunting locomotives. Whilst some were sold to larger industrial concerns, the growing interest in preserving steam traction saw many locomotives being scrapped and it was mainly those examples sold to industry which were fortunate to enter preservation once the nascent heritage lines appreciated their value for both maintenance tasks and standby passenger duty.")]), _vm._v(" "), _c('p', {
    staticClass: "h4_1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("1.2.1.1: Hudswell Clarke & Company")])]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Builder")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Hudswell Clarke & Co")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Year Built")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1961")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Engine")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Gardner 8L3 rated at 204 hp @ 1200 rpm")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Transmission")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Mechanical")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("BR Fleet Numbers")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("D2510–2519")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "fimg"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg11-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("D2511 stands in Oxenhope sidings (KWVR) on 10 October 2015 where it is based for stock shunting duties in the carriage sidings and workshops.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("D2511 entered service at Barrow depot in August 1961 and remained there until withdrawn in December 1967. It was sold to industry from where it entered preservation with the Keighley & Worth Valley Railway (KWVR) in August 1977.")]), _vm._v(" "), _c('p', {
    staticClass: "h4_1"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("1.2.1.2: North British Locomotive Company")])]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Builder")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("North British Locomotive Co")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Year Built")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1957–1961")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Engine")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("North British M.A.N. W6V rated at 225 hp @ 1100 rpm")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Transmission")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Hydraulic")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("BR Fleet Numbers")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("11708–719 (later D2708–2719); D2720–2780")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("D2767 entered service at Eastfield Depot in August 1960 from where it was withdrawn in June 1967 and sold into industry. It entered preservation with the Bury Transport Museum, associated with the nascent East Lancashire Railway (ELR), in 1981 and was subsequently sold to the Scottish Railway Preservation Society (SRPS) at Bo’ness where it is based as at July 2016.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "fimg"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg12-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(" D2767 is displayed as an exhibit in the SRPS Scottish Railway Museum at Bo’ness on 24 August 2009 whilst awaiting its turn for overhaul.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4_1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("1.2.1.3: Ruston & Hornsby")])]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Builder")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Ruston & Hornsby")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Year Built")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1963 [650]; 1959 [651–654]")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Engine")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Ruston & Hornsby 6-cylinder 6VPH rated at 165 hp @ 1250 rpm")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Transmission")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Electric")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("BR Fleet Numbers")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("PWM650–654; TOPS = 97650–654")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("PWM651 entered service as Western Region Departmental stock, numbered Permanent Way Machine (PWM) 651, at Cardiff in August 1959 where it worked until withdrawal in October 1998; in 1979 it was renumbered into the Departmental Class 97 series to become 97651. It initially entered preservation with the Swindon & Cricklade Railway (SCR) but was subsequently sold to the Northampton & Lamport Railway (NLR) then to the Strathspey Railway (SR) where it is resident as at December 2016.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "fimg"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg12-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(" 97651 lies stored in the sidings at Chapel Brampton on 13 August 2005 during its sojourn on the NLR.")])])]), _vm._v(" "), _c('h5', {
    staticClass: "h5"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("Builder")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("English Electric")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Year Built")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1957")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Engine")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("English Electric 6RKT rated at 500 hp @ 750 rpm")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Transmission")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Electric")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("BR Fleet Numbers")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("D0226–7")]), _vm._v(" "), _c('p', {
    staticClass: "h4_1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("1.2.1.4: English Electric Demonstrator")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("D0226 was one of two prototype shunting locomotives produced by English Electric; supplied with a 500 hp engine, D0226 had an electric transmission whilst D0227 had a hydraulic transmission in order to provide comparison between the two transmission systems. Both locomotives were intended for shunting and trip working duties but in service they were found too powerful for shunting duties and not powerful enough for trip workings.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("D0226 entered service at Stratford depot along with D0227 in July 1957 from where they were withdrawn and returned to English Electric in October 1960. D0226 remained in store until March 1966 when it entered preservation with the Keighley & Worth Valley Railway (KWVR) on ‘long term loan’. On the KWVR it has proved a valued locomotive capable of working both service trains and the numerous infrastructure services required by the maintenance teams.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "fimg"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg13-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("D0226 Vulcan powers a maintenance train in Oakworth yard (KWVR) on 16 August 2014.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4_1"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("1.2.2: TOPS Designs")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Despite the cull of small shunting locomotives whilst BR contracted during the 1960s, the application of the TOPS system in the 1970s was still able to identify thirteen classes which operated on BR’s network. The withdrawal of these locomotives still continued with many being sold to industry but enthusiasts were beginning to appreciate both the history and value of them hence the increase in the number of locomotives which entered preservation. Some examples were bought directly from BR itself or from industrial concerns once their working lives had come to an end but all were bought as appreciation of their value to heritage lines became increasingly clear.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("NOTE:  The classes in this and following sections are detailed in numerical order of TOPS classification rather than by date of introduction or numerical order of BR fleet number.")]), _vm._v(" "), _c('p', {
    staticClass: "h4_1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("1.2.2.1: Class 01 - Andrew Barclay and Sons")])]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Builder")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Andrew Barclay & Sons")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Year Built")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1956")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Engine")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Gardner 6L3 rated at 153 hp @ 1200 rpm")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Transmission")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Mechanical")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("BR Fleet Numbers")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("11503–6 (later D2953–6); TOPS = 01.001–2")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("D2956 entered service as 11506 at Stratford depot in March 1956 and was withdrawn from Doncaster depot in January 1966 whence it was sold to industry. It was used by Mayer-Newman scrap merchants until withdrawn from service in 1984 with a defective transmission. It was subsequently donated by the company to the East Lancashire Railway (ELR), arriving in Bury during 1985.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The history of this locomotive has been confused by the actions of BR who, when D2956 was withdrawn, allocated the fleet number to Departmental locomotive 81 which was a similar locomotive in appearance. The latter locomotive was also sold to industry on withdrawal from BR service but was cut up at the end of its industrial service, although confusion still arises as the original D2956 also carries the works plate of AB 397 instead of its actual AB 398 works plate.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "fimg"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg14-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("D2956 takes a break from shed pilot duties on 20 May 2006 as it rests in Castlecroft yard (ELR) adjacent to the ELR’s Bury–Rawtenstall line.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4_1"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("1.2.2.2: Class 02 – Yorkshire Engine Company")])]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Builder")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Yorkshire Engine Co")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Year Built")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1960–61")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Engine")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Rolls Royce C6NFL rated at 179 hp @ 1800 rpm")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Transmission")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Hydraulic")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("BR Fleet Numbers")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("D2850–2869; TOPS = 02.001–004")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("History:")]), _vm._v(" This class of locomotive was ordered to replace the L&YR Class 19 0-4-0ST locomotives used on Merseyside dock lines.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("D2860 entered service at Fleetwood depot in September 1961 and was withdrawn from Allerton Depot in December 1970. It remained in store until entering preservation with the National Rail Museum (NRM) at York where it is often used as ‘shed pilot’ for stock moves around the NRM site.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "fimg"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg15-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(" On 22 June 2010 D2860 shunted A1 Class 4-6-2 60163 Tornado into the Display Yard whilst …")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "fimg"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg15-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(" … on 29 February 2016 it shunted A3 Class 4-6-2 60103 Flying Scotsman into the Display Yard prior to the start of a photography charter organised by the NRM.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4_1"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("1.2.2.3: Class 03 – British Railways")])]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Builder")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("BR Doncaster; BR Swindon")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Year Built")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1957–1961")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Engine")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Gardner 8L3 rated at 204 hp @ 1200 rpm")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Transmission")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Mechanical")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("BR Fleet Numbers")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("11187–11211 (later D2000–2024); D2025–2199; D2370–2399; TOPS = 03.001–399")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("History:")]), _vm._v(" In the early days of BR the supply of small shunting locomotives was obtained from private industry but in 1957 BR decided to produce its own design based on the Drewry prototype that had been supplied in June 1947, and subsequently taken into Southern Region Departmental stock as DS1173 in 1948. The initial order for forty-three locomotives was placed with Swindon Works with subsequent orders being shared between Swindon and Doncaster Works.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("D2148 entered service at York depot in June 1960 and was withdrawn from Healey Mills depot in November 1971 whence it was sold into industrial service. It entered preservation with Southport’s Steamport Museum in March 1987 and moved with that operator’s transfer to the Ribble Steam Railway (RSR) in Preston during 1999.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "fimg"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg16-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("D2148 forms the rear of a Strand Road–Riversway shuttle service as it crosses the Marina Bridge (RSR) on 3 October 2015.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "fimg"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg17-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(" D2072 carries TOPS number 03072 on 6 March 2015 as it passes Newby Bridge (LHR) with the Haverthwaite–Lakeside leg of a tour of the line chartered by the Preserved Locomotives Enthusiast Group (PLEG).")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "fimg"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg17-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(" Operating as 03066 in BR’s corporate blue livery, D2066 draws Ivatt Class 4MT 2-6-0 43106 onto the turntable at Barrow Hill on 23 September 2015 during a steam gala event.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("D2072 entered service at Bradford (Hammerton St) depot in October 1959 and was withdrawn from Darlington depot in March 1981 to enter preservation with the Lakeside & Haverthwaite Railway (LHR).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("D2117 entered traffic at Swansea Danycraig depot in September 1959 and was withdrawn from Wigan Springs Branch depot in October 1971 whence it entered preservation with the Lakeside & Haverthwaite Railway (LHR) shortly after.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("D2066 entered service at York depot in August 1959 and was withdrawn from Gateshead depot in January 1988 whence it was sold into industrial service. It subsequently entered preservation with the Barrow Hill Roundhouse (BHR) where it sees regular use as shed pilot.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "fimg"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg17-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(" Partnered by sister locomotive D2072 in black livery, D2117 stands in Haverthwaite yard on 16 November 2008 prior to working a Haverthwaite–Lakeside service during a rare Diesel Day on the LHR.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4_1"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("1.2.2.4: Class 04 – Drewry Car Company")])]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Builder")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Vulcan Foundry; RSH Newcastle; RSH Darlington")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Year Built")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1952–1962")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Engine")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Gardner 8L3 rated at 204 hp @ 1200 rpm")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Transmission")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Mechanical")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("BR Fleet Numbers")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("11100–11115 (later D2200–2214); 11121–11135 (later D2215–2229); 11149–11160 (later D2230–2241); 11212–11249 (later D2242–2259); D2260–2340; D2341; TOPS = Class 04 (TOPS numbers never carried)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("History:")]), _vm._v(" This class originated with the demonstrator locomotive supplied to the London North Eastern Railway Company in 1947 and which the company tested but rejected because it was looking to design its own shunting locomotive. With the formation of BR shortly after in 1948, the locomotive was trialled with the Southern Region where it was purchased and transferred to Departmental stock to become DS1173. In March 1967 the locomotive was returned to operating stock based at Hither Green depot where it was renumbered to D2341 and worked until withdrawn from Ashford depot in December 1968.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("D2203 entered service at March depot in June 1952 and was withdrawn from Crewe Works in December 1967 whence it was sold into industrial service. It entered preservation with the Yorkshire Dales Railway (YDR) – later Embsay & Bolton Abbey Railway (EBAR) – where it acts as the line’s ‘rescue’ locomotive as at December 2016.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "fimg"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg18-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("D2203 shunts coach bogies at Embsay station (EBAR) on 27 September 2015.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "fimg"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg19-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(" D2302 stands in the store line at HNRC’s base at Barrow Hill Roundhouse on 15 July 2007.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "fimg"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg19-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(" D2246 stands in the yard at Buckfastleigh on 20 July 2005 – the base of the SDR.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("D2302 entered service at Lincoln depot in October 1960 and was withdrawn from Derby depot in June 1969 whence it was sold into industrial service. It entered preservation in September 1993 with the South Yorkshire Railway (SYR) as part of the Harry Needles (HNRC) collection; it was sold to the D2578 Group in November 2011 and transferred to a new base at Moreton Park (by Hereford).")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "fimg"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg19-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(" D2203 awaits departure from Bolton Abbey (EBAR) on 29 October 2006 with the 12:30 service to Embsay formed of 3-car Class 107 trainset 52005+59791+52031.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("D2246 entered traffic at Hull depot in December 1956 and was withdrawn from Knottingley depot in July 1968 whence it entered industrial service. It subsequently became part of the HNRC collection in 1994 from where it was sold to enter preservation with the South Devon Railway (SDR) in January 2001.")]), _vm._v(" "), _c('p', {
    staticClass: "h4_1"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("1.2.2.5: Class 05 – Hunslet Engine Company")])]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Builder")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Hunslet Engine Company")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Year Built")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1955–1961")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Engine")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Gardner 8L3 rated at 204 hp @ 1200 rpm")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Transmission")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Mechanical")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("BR Fleet Numbers")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("11136–11176 (later D2550–2573); D2574–2618; TOPS = 05.001")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("D2595 entered service at York depot in January 1960 and was withdrawn from Thornton Junction depot in June 1968 whence it was sent to its builder (Hunslet Engine Company) for scrapping. After a lengthy period in store it was sold into industry in 1969 from where it was sold into preservation with the East Lancashire Railway (ELR). It was subsequently sold to a member of Steamport and transferred to the Southport site in 1989 then subsequently to the Ribble Steam Railway (RSR) site in 1999.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("D2554 entered service as 11140 at Parkeston Quay depot in May 1956 and was transferred to Ryde depot (Isle of Wight) on 7 June 1966. It was transferred to Departmental stock in February 1981 and renumbered to 97803. It entered preservation with the neighbouring Isle of Wight Steam Railway (IoWSR) on 23 August 1984.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "fimg"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg20-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(" Now restored to Green livery, D2554 was a display item at the Haven St base of the IoWSR on 12 March 2011.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "fimg"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg20-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(" D2595 crosses the Marina Bridge (RSR) on 7 March 2015 whilst working a shuttle service from Riverview–Strand Rd.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _vm._v("D2595 is a stalwart of the RSR fleet with scenes from the line including:")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "fimg"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg21-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(" Standing at the head of a trainset of bitumen tanks, associated with the Ribble Rail contract with Lindsey Oil Refinery, at Riversway station on 7 March 2015 whilst awaiting its next duty during a gala event.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "fimg"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg21-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(" Standing in the ‘new’ facility yard on 11 January 2004 in BR green livery.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "fimg"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg21-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(" Entering the RSR ‘estate’ on 23 February 2011 whilst powering a Strand Road–Riversway shuttle service.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4_1"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("1.2.2.6: Class 06 – Andrew Barclay and Sons")])]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Builder")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Andrew Barclay and Sons")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Year Built")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1956–1960")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Engine")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Gardner 8L3 rated at 204 hp @ 1200 rpm")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Transmission")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Mechanical")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("BR Fleet Numbers")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("11177–11186 (later D2400–2409); D2410–D2444; TOPS = 06.001–010")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("06003 entered service as D2420 at Kittybrewster depot in February 1959 and was withdrawn from Eastfield depot in February 1981. It was transferred to Reading for Departmental Service in March 1981, being renumbered 97804 in May 1981. It was withdrawn in August 1985 and, following a short period in store, was sent for scrap in late September 1985. It became part of the HNRC collection between February 1987 and July 1998 and subsequently entered preservation when sold to the Shunters Heritage Trust, based at the Peak Railway (PR), during 2013.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "fimg"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg22-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("06003 enters Barrow Hill’s display yard (BHR) on 6 October 2002 whilst working a shuttle service in top ’n tail mode with Class 08 08899 during a gala event.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4_1"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("1.2.2.7: Class 07 – Ruston & Hornsby")])]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Builder")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Ruston & Hornsby")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Year Built")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1962")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Engine")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Paxman 6RPHL rated at 275 hp @ 1360 rpm")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Transmission")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Electric")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("BR Fleet Numbers")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("D2985–2998; TOPS = 07.001–014")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("History:")]), _vm._v(" This fleet of locomotives was ordered as replacement for the USA Class 0-6-0T used in Southampton Docks and the surrounding area.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("07001 entered service as D2985 at Eastleigh depot in June 1966 from where it was withdrawn on 1 July 1977 and sold into industrial service. It later became part of the HNRC collection but was main-line registered for use as a spot hire locomotive until sold into preservation with the Heritage Shunters Trust in December 2012 who moved it to their base at Peak Rail (PR).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("07005 entered service as D2989 at Eastleigh depot in June 1962 from where it was withdrawn on 1 July 1977 and sold into industrial service. It subsequently became part of the HNRC collection and was stored at the Battlefield Line (BL) until sold to the Great Central Railway (GCR) during early 2009.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "fimg"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg23-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(" 07001 is a display item during a Barrow Hill (BHR) diesel gala on 8 August 2009.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "fimg"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg23-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(" 07005 is noted stored in the GCR’s Swithland Sidings on 13 November 2008 as it awaited its turn to be restored to working order.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4_1"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("1.2.2.8: Classes 08 thru 13 – British Railways")])]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Builder")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("BR Crewe; BR Darlington: BR Derby; BR Doncaster; BR Horwich")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Year Built")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1952–1962")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Engine")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("English Electric 6KT rated at 350/400 hp @ 630 rpm")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("Transmission")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Electric")]), _vm._v(" "), _c('p', {
    staticClass: "h5_1"
  }, [_vm._v("BR Fleet Numbers")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("13000–13366 (later D3000–D3366); D3367–4192; TOPS = 08.001–08.958 See also "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("History ")]), _vm._v("(below)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("History:")]), _vm._v(" Whilst the LMSR was developing its large shunter design in the 1930s, the other Pre-Grouping companies were also trialling similar locomotives but, when BR was created on 1 January 1948, the CME (Robert Riddles) elected to continue with the LMSR design as the BR Standard large shunting locomotive. In the early days of construction alternative engines were tested (namely Crossley (D3117–3126) and Blackstone (later Class 10) with a further trialling of BTH/GEC traction motors) but the final choice was the combination of English Electric engine and electrical equipment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Class 10 design with Blackstone engine and GEC electrical equipment proved sufficiently successful however that Doncaster built five batches (D3137–3151; D3439–3453; D3473–3502; D3612–3651; D4049–4094) totalling 146 locomotives which entered service at various Eastern Region depots.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Whilst nominally built as ‘standard’ locomotives there were variations introduced both during the build and afterwards, the prime example being the uprating of the engine from 350 hp to 400 hp. In a further development, twenty-six locomotives were built with higher gearing for operation on Southern Region lines (D3665–3671; D3719–21; D4099–4114; later TOPS = Class 09) whilst in 1992–3 a further twelve were rebuilt to this specification.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Earlier between 1985–1987, three locomotives were modified with cut-down cabs and renumbered 08993–08995 to allow them to replace Class 03 locomotive working on the reduced height Burry Port and Gwendraeth branch line in South Wales.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A final modification was made in February 1974 when three pairs of locomotives were converted by Doncaster Works to Master + slave units for heavy shunting in the new Tinsley marshalling yard; D4188 + D3698, D4190 + 4189 and D4187 + D3697 becoming D4500/01/02 respectively (later TOPS 13.003/01/02 respectively)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TOPS Classification:")]), _vm._v("  The introduction of TOPS in the late 1960s and its application to Fleet Operations from 1974 allowed these various sub-groups to be identified more clearly:")]), _vm._v(" "), _c('p', {
    staticClass: "hang1p"
  }, [_c('span', {
    staticClass: "hang_h"
  }, [_vm._v("08.0 =")]), _vm._v(" Standard locomotive")]), _vm._v(" "), _c('p', {
    staticClass: "hangh"
  }, [_c('span', {
    staticClass: "hang_h"
  }, [_vm._v("08.9 =")]), _vm._v(" 3 locomotives with reduced cab height")]), _vm._v(" "), _c('p', {
    staticClass: "hangh"
  }, [_c('span', {
    staticClass: "hang_h"
  }, [_vm._v("09.0 =")]), _vm._v(" Locomotive with higher gearing")]), _vm._v(" "), _c('p', {
    staticClass: "hangh"
  }, [_c('span', {
    staticClass: "hang_h"
  }, [_vm._v("09.1 =")]), _vm._v(" Later conversion of locomotives with 110v electrical equipment; none preserved as at December 2016")]), _vm._v(" "), _c('p', {
    staticClass: "hangh"
  }, [_c('span', {
    staticClass: "hang_h"
  }, [_vm._v("09.2 =")]), _vm._v(" Later conversion of locomotives with 90v electrical equipment; none preserved as at December 2016")]), _vm._v(" "), _c('p', {
    staticClass: "hangh"
  }, [_c('span', {
    staticClass: "hang_h"
  }, [_vm._v("10.0 =")]), _vm._v(" Doncaster-built locomotives with Blackstone engine and GEC electrical equipment (TOPS numbers never carried)")]), _vm._v(" "), _c('p', {
    staticClass: "hangh"
  }, [_c('span', {
    staticClass: "hang_h"
  }, [_vm._v("11.0 =")]), _vm._v(" Original LMS locomotives (12033–12138); see "), _c('a', {
    attrs: {
      "href": "#/xhtml/#sec1-1-2"
    }
  }, [_vm._v("Section 1.1.2")])]), _vm._v(" "), _c('p', {
    staticClass: "hangh"
  }, [_c('span', {
    staticClass: "hang_h"
  }, [_vm._v("12.0 =")]), _vm._v(" Southern Region design based on LMS design (numbered 15211–15235 under BR fleet system); one example preserved as at December 2016 (TOPS numbers never carried)")]), _vm._v(" "), _c('p', {
    staticClass: "hangh"
  }, [_c('span', {
    staticClass: "hang_h"
  }, [_vm._v("13.0 =")]), _vm._v(" Master + slave units; locomotives cut up on withdrawal from service.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("13265 entered service at Swansea Danycraig depot in August 1956 and was withdrawn from service at Cardiff Canton depot in September 1983 whence it was transferred to Swindon Works for scrapping. After a lengthy period in store it entered preservation with the Llangollen Railway (LR) in March 1986.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "fimg"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg25-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Recreating a scene from the past, 13265 performs shunting duties at the Pentre Felin yard of the LR on 26 March 2011.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "fimg"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg26-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("D3000 is a display item at Barrow Hill (BHR) on 5 October 2003 during a BHR diesel gala event.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Class doyen D3000 entered service as 13000 at Toton depot in October 1952 before transfer to Western Region depots including Bristol Bath Road from where it was withdrawn in November 1972 and sold to the National Coal Board (NCB) for further service. It entered preservation with the Southern Diesel Group (SDG) in December 1986 but passed through numerous owners until moving to Peak Rail (PR) in February 2011 where, as at 2016, it is undergoing restoration to working order.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _vm._v("08266 entered service as 13336 at Darnall depot in March 1957 and was withdrawn from Shirebrook depot in March 1985. It was moved to Swindon for scrapping whence it entered preservation with the Keighley & Worth Valley Railway (KWVR). 08911 entered service as D4141 at Carnforth depot in September 1962 and was withdrawn from Holbeck depot in February 2004 whence it entered service with the National Rail Museum (NRM) at York.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "fimg"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg27-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(" D3586 runs onto Bridgnorth depot (SVR) on 24 September 2005 whilst acting as shed pilot during the SVR’s annual September Steam Gala.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The locomotive was named "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Matey")]), _vm._v(" on 14 January 2007 in tribute to Ray Towell, a long serving member of the NRM staff who used the name for many of those with whom he came into contact. Sadly, Ray suffered a fatal heart attack on 28 March 2016 and was buried in his home town of Oakham.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "fimg"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg27-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(" Fresh from overhaul and re-livery into Railfreight Grey colours, 08266 pilots recently bought Class 08/9 08995 Ashburnham out of Oxenholme (KWVR) on 18 June 2016 whilst working a service to Keighley on a Diesel Shunters gala event.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("D3586 entered service at Burton depot in November 1958 and was withdrawn from Leicester depot in September 1985 whence it was sent to Swindon Works for scrapping. It was bought by the Severn Valley Railway (SVR) and entered preservation in March 1986.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "fimg"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg27-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(" 08911 Matey stands inside the NRM at York on 23 November 2014.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "fimg"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg28-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(" D4157 was hired to the NRM, which based it at its Shildon Centre and where it was noted on yard pilot duties on 19 October 2012.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("D3937 entered service at Royston depot in March 1960 and was withdrawn from Landore depot in May 1989 whence it moved to the Fire Training College at Moreton-in-Marsh. It entered preservation with the Dean Forest Railway (DFR) in 1999.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "fimg"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg28-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(" 08.944 awaits departure from Bury (ELR) on 20 November 2004 with a service to Rawtenstall comprising Class 207 trainset 1305.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("D4157 entered service at Lancaster Green Ayre depot in December 1962 and was withdrawn from Headquarters stock in June 2005 to pass into preservation with the Gloucestershire Warwickshire Railway (GWR).")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "fimg"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg28-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("D3937 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gladys")]), _vm._v(" acts as shed pilot at Bridgnorth (SVR) on 21 September 2003 whilst on indefinite loan from the DFR.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("08944 entered service as D4174 at Newport Ebbw Junction depot in August 1962 and was withdrawn from Old Oak Common depot in May 1998 whence it entered preservation with the East Lancashire Railway (ELR).")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "fimg"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg29-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The line-up of locomotives in Buckley Wells yard on 28 August 2007 included (from left to right) 08.994 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Spirit of Innovation;")]), _vm._v(" 08.995; 08.623; 08479 and 08.445.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Class 08 has proved a successful design with BR and, following withdrawal from service, many examples had a successful second life either as contractors’ locomotives or as motive power on heritage lines. One such line is the East Lancashire Railway (ELR) which offers facilities to the neighbouring Metrolink Network with which it has a rail connection.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In August 2007 the ELR site at Buckley Wells offered stabling facilities for rail-borne traffic during a major Metrolink engineering project, at the end of which an evening photographers’ night session was arranged with the shunting locomotives used on the contract.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _vm._v("Class 09 D3666 entered traffic at Eastleigh depot in February 1959 and was withdrawn from Selhurst depot in September 1992 whence it entered service with the South Devon Railway (SDR). In 2010 the SDR bought 09.010 and intended using D3666 as spares but in February 2011 the locomotive was bought by GB Railfreight and returned to main line service as 09002.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Class 09 D4100 entered service at Ashford depot in October 1961 and was withdrawn from Hither Green depot in February 2004. It remained in store until joining the HNRC collection in April 2010 before entering preservation with the Severn Valley Railway (SVR) in February 2013.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "fimg"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg30-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("D3666 lies stabled in SDR’s Buckfastleigh yard on 20 July 2005")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "fimg"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg30-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("D4100 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dick Hardy")]), _vm._v(" pilots Class 08 D3022 out of Bewdley (SVR) on 21 May 2016 whilst powering the 10:10 Bewdley–Kidderminster service during the SVR’s 2016 annual diesel gala.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "fimg"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg31-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("D4092 is a display item at Barrow Hill (BHR) on 23 September 2015 during a diesel gala event.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "fimg"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg31-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("D4067 Margaret Ethel – Thomas Alfred Naylor lies stabled in the GCR’s Loughborough Central yard on 29 January 2009.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Class 10 D4092 entered service at Darnall depot in May 1962 and was withdrawn from New England depot in September 1968 whence it entered industrial service with the NCB. It subsequently became part of the HNRC collection at the South Yorkshire Railway (SYR) before moving to the HNRC base at Barrow Hill (BHR).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Class 10 D4067 entered service at Darnall depot in April 1961 and was withdrawn from Shirebrook depot in December 1970 whence it entered industrial service with the NCB. It entered preservation with the Great Central Railway (GCR) in February 1980.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8418ec00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Chapter01.vue
// module id = 72
// module chunks = 0